module.exports = __webpack_public_path__ + "img/1f682.65bba5c.svg";